module.exports = __webpack_public_path__ + "static/react-native-icon-b76b58b671617252ff006a2ff02d0c56.png";